import React from 'react';
import style from './style.module.scss';

interface Props {
    label: string;
}

const Label: React.FC<Props> = ({ label }) => {
    return ( 
        <div className={style.label}>
            {label}
        </div>
    );
};
 
export default Label;